module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_stenungsund-3dfb3008b83f8f85404bb846d6547442.png";